import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    heading: "1. Acceptance of Terms",
    body: [
      "These Terms of Service (\"Terms\") govern your use of ChannelHQ (\"the Service\"). By creating an account or using the Service you agree to these Terms. This is a demo product and these Terms are provided as generic boilerplate.",
    ],
  },
  {
    heading: "2. Your Account",
    body: [
      "You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account.",
      "You agree to provide accurate information and to use the Service only for lawful purposes.",
    ],
  },
  {
    heading: "3. Acceptable Use",
    body: [
      "You agree not to misuse the Service, including attempting to disrupt it, access it without authorization, or use it to create unlawful, infringing, or harmful content.",
      "AI-generated script drafts are provided as a starting point. You are responsible for reviewing and editing any content before publishing it.",
    ],
  },
  {
    heading: "4. Content Ownership",
    body: [
      "You retain ownership of the channels, cards, notes, and scripts you create in your workspace. You grant us the limited rights necessary to store and display that content back to you and to process AI requests you initiate.",
    ],
  },
  {
    heading: "5. Disclaimer & Limitation of Liability",
    body: [
      "The Service is provided \"as is\" without warranties of any kind. To the maximum extent permitted by law, ChannelHQ is not liable for any indirect or consequential damages arising from your use of the Service.",
    ],
  },
  {
    heading: "6. Changes & Contact",
    body: [
      "We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the updated Terms.",
      "For questions about these Terms, contact us at support@channelhq.app.",
    ],
  },
];

export default function Terms() {
  return <LegalPage title="Terms of Service" updated="June 1, 2026" sections={SECTIONS} />;
}
